export default "__VITE_ASSET__PtfyvNPy__"